import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generatePrimaryLink} from '#core/application/modules/tiles/link/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateScrollButtonPane} from '#core/application/modules/tiles/control-button/index.js';

import PROMOTION_QUICK_LINKS from './promotion-quick-links.palette-schema.yaml';

registerTileSchema(PROMOTION_QUICK_LINKS);

export function generatePromotionQuickLinks(TILE) {
    const PRIMARY_LINK = generatePrimaryLink(TILE.PROMOTION_QUICK_LINK);

    const showIcon = TILE.PROMOTION_QUICK_LINK.PRIMARY_LINK_ICON_COLOR !== 'transparent';

    return {
        menuRow: {
            item: {
                selected: PRIMARY_LINK,
                unselected: PRIMARY_LINK,
                indicator: {
                    style: {
                        base: {
                            height: 0,
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },
            chevronIcon: icon(TILE.PROMOTION_QUICK_LINK.PRIMARY_LINK_ICON_COLOR, showIcon ? 'chevron-right' : false),
            buttonScrollPane: generateScrollButtonPane(TILE.PROMOTION_QUICK_LINKS_SCROLL_BUTTON),
            showItemIcon: showIcon,
            _mobile_showItemIcon: showIcon,
        },
        menuRowSkeleton: {
            container: {
                style: {
                    _mobile_padding: '0 8px',
                },
            },
            linkPlaceholder: generateSkeletonPart({
                ...TILE.PROMOTION_QUICK_LINK_SKELETON_PART,
                SKELETON_BORDER_RADIUS: TILE.PROMOTION_QUICK_LINK.PRIMARY_LINK_BORDER_RADIUS,
            }),
            iconPlaceholder: generateSkeletonPart(TILE.PROMOTION_QUICK_LINK_SKELETON_PART),
        },
    };
}
